import React from 'react'
import ReactDOM from 'react-dom'
import App from './routes/App'
import './styles/main.scss'

ReactDOM.render(<App />, document.getElementById('root'))
